import React from "react"

import { productUnitsSymbol } from "constant"

const StrrdmRequestTableRow = (props) => {
  const { requestedItem } = props
  return (
    <tr>
      <td>
        {requestedItem.foodName}{" "}
        {requestedItem.isSimple ? "" : requestedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.requestedQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
    </tr>
  )
}

export default StrrdmRequestTableRow